// extracted by mini-css-extract-plugin
module.exports = {"searchInput":"searchInput--3HL8e","searchResult":"searchResult--9J6Oj"};